import { Injectable } from '@angular/core';
import { CiudadanoModel } from './ciudadanos/models/ciudadano.model';

export type CiudadanoHasCard = CiudadanoModel & {
    hasFisica :boolean;
    hasVirtual: boolean;
    hasApp : boolean;
};

@Injectable({
  providedIn: 'root'
})
export class TransformadorDeCiudadanosService {
  public constructor() { }

  public transform(ciudadano: CiudadanoModel): CiudadanoHasCard {
    const hasVirtual = ciudadano.tarjetas.some(t => t.virtual);
    const hasFisica = ciudadano.tarjetas.some(t => !t.virtual);

      return  {
        ...ciudadano,
        hasFisica: hasFisica,
        hasVirtual: hasVirtual,
        hasApp: false,
      };
    }
}
